import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Chip from '@material-ui/core/Chip';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { instanceAxios } from '../../InstanceAxios';
import { MSG_ERRO } from '../../consts/common';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  loading: {
    marginLeft: '50%',
  },
  title: {
    paddingBottom: '2%',
  },
}));

function IntencaoAssinatura() {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [intencoes, setIntencoes] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');
  const [columns, setColumns] = useState([
    { id: 'usuario', label: 'Usuário', minWidth: 140 },
    { id: 'plano', label: 'Plano Assinatura', minWidth: 140 },
    { id: 'status', label: 'Status', minWidth: 70 },
    { id: 'cupom', label: 'Cupom', minWidth: 70 },
  ]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [busca, setBusca] = useState('');
  const [status, setStatus] = useState('Inativo');

  useEffect(() => {
    fetchIntencao(page, limit, busca, status);
  }, []);

  const clickAlert = () => {
    setAlert(false);
    setAlertType('');
    setMessage('');
  };

  const fetchIntencao = async (p, l, b, s) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/signatureIntention?busca=${b}&limit=${l}&page=${p}&status=${s}`)
      .then((res) => {
        const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];

        setIntencoes(rows);
        setCount(res?.data?.count || 0);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        const msg = err.data ? err.data.message : MSG_ERRO;
        setMessage(msg);
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchIntencao(newPage, limit, busca, status);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setLimit(event.target.value);
    fetchIntencao(page, event.target.value, busca, status);
  };

  const handleBusca = (event) => {
    setBusca(event.target.value);
    setPage(0);
    setLimit(10);
    fetchIntencao(0, 10, event.target.value, status);
  };

  const handleStatus = async () => {
    const s = status === 'Ativo' ? 'Inativo' : 'Ativo';
    setStatus(s);
    setPage(0);
    setLimit(10);
    fetchIntencao(0, 10, busca, s);
  };

  return (
    <>
      <Snackbar open={alert} autoHideDuration={6000} onClose={clickAlert}>
        <Alert variant="filled" severity={alertType} onClick={clickAlert}>
          {message}
        </Alert>
      </Snackbar>
      <Paper className={classes.root}>
        <Collapse in={ready}>
          <Grid
            container
            style={{ paddingLeft: 10, paddingRight: 10, paddingTop: '1%' }}
          >
            <Grid item xs={12}>
              <div align="center" className={classes.title}>
                <h1>Intenção Assinatura</h1>
              </div>
            </Grid>
            <Grid container>
              <Grid item xs={6}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={status === 'Ativo'}
                        onChange={handleStatus}
                        color="primary"
                      />
                    }
                    label={status}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6}>
                <div align="right">
                  <FormControl variant="outlined">
                    <TextField
                      id="busca"
                      label="Busca"
                      value={busca}
                      onChange={handleBusca}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align="center"
                    style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(intencoes) ? intencoes : []).map((i) => (
                <TableRow key={i.id}>
                  <TableCell component="th" scope="row" align="center">
                    {i.User ? i.User.nome : ''}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {i.PlanoAssinatura ? i.PlanoAssinatura.nome : ''}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <Chip
                      label={i.status}
                      color="primary"
                      style={
                        i.status === 'Ativo'
                          ? {
                              backgroundColor: '#32CD32',
                            }
                          : {
                              backgroundColor: '#FF0000',
                            }
                      }
                    />
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    {i.cupom ? i.cupom : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[10, 15, 25]}
                count={count}
                rowsPerPage={limit}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>
    </>
  );
}

export default IntencaoAssinatura;
